<template>
<!-- START JUMBOTRON -->
  <div class="jumbotron" data-pages="parallax">
    <div class="container-fluid container-fixed-lg sm-p-l-20 sm-p-r-20">
      <div class="inner">
        <!-- START BREADCRUMB -->
        <slot></slot>
        <!-- END BREADCRUMB -->
        <div class="row">
          <div class="col-lg-7 col-md-6 ">
            <!-- START PANEL -->
            <div class="full-height">
              <div class="panel-body text-center">
                <img v-if="image.length > 0" class="image-responsive-height demo-mw-600" :src="imagePath()" alt="">
              </div>
            </div>
            <!-- END PANEL -->
          </div>
          <div class="col-lg-5 col-md-6 ">
            <!-- START PANEL -->
            <div class="panel panel-transparent">
              <div class="panel-heading">
                <div class="panel-title">{{ title }}</div>
              </div>
              <div class="panel-body">              
                <h3>{{ subtitle }}</h3>
                <p v-html="description"></p>                
                <p v-if="hint.length > 0" class="small hint-text m-t-5" v-html="hint"></p>
                <br>                
                <button @click="linkAction" v-if="linkTitle.length > 0" class="btn btn-primary btn-cons">{{ linkTitle }}</button>
                <slot name="search"></slot>
                <slot name="filter"></slot>
              </div>
            </div>
            <!-- END PANEL -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
  export default {
    name: 'Jumbotron',    
    props: {
      title: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      hint: {
        type: String,
        default: ''
      },
      linkTitle: {
        type: String,
        default: ''
      },
      linkHref: {
        type: String,
        default: ''
      },
      linkAction: {
        type: Function,
        default: () => {}
      },
      image: {
        type: String,
        default: ''
      }
    },
    methods: {
      imagePath() {
        return this.image;
      }
    }
  }
</script>

<style>  
</style>


// WEBPACK FOOTER //
// jumbotron.vue?60ceb336